/* unplugin-vue-components disabled */import { render } from "./ai-select.vue?vue&type=template&id=b35fbf4c&scoped=true"
import script from "./ai-select.vue?vue&type=script&lang=js"
export * from "./ai-select.vue?vue&type=script&lang=js"

import "./ai-select.vue?vue&type=style&index=0&id=b35fbf4c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35fbf4c"],['__file',"src/components/ai-chat-v2/ai-assistant/ai-input/ai-select.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b35fbf4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b35fbf4c', __exports__)) {
    api.reload('b35fbf4c', __exports__)
  }
  
  module.hot.accept("./ai-select.vue?vue&type=template&id=b35fbf4c&scoped=true", () => {
    api.rerender('b35fbf4c', render)
  })

}


export default __exports__